import layout from './layout/layout';
import fulltimeJob from './jobs/job';
import login from './auth/login';
import partnerProfile from './partner/partner';
import fileupload from './fileupload/fileupload';
import payment from './payment/payment';
import applicants from './applicants/applicants';
import subscriptions from './subscriptions/subscriptions';
import externalPartner from './partner/externalPartner';
import chat from './chat/chat-messages'
import events from './events/events'
import partnerUser from './partner/partnerUser'
import workerHiredForm from './worker-hire-form/workerHiredForm'
import pma from './pma/pma';
import cvSearch from './cv-search/cv-search';
import vetting from './vetting/vetting';
import enterprise from './enterprise/enterprise';
import massHiring from './mass-hiring/mass-hiring';
import whatsappInbox from './whatsapp/inbox/whatsappInboxSlice';
import whatsappTemplates from './whatsapp/templates/whatsapp-templates';
import interviewScheduling from './interview-scheduling/interview-scheduling';
import onboarding from './onboarding/onboarding';
import screeningQuestions from './screening-questions/screening-questions';
import onboardingTasks from './onboarding-tasks/onboarding-tasks';
import interviewEvaluations from './interview-evaluations/interview-evaluations';

const appReducer = {
    layout,
    login,
    fulltimeJob,
    partnerProfile,
    fileupload,
    payment,
    applicants,
    subscriptions,
    externalPartner,
    chat,
    events,
    partnerUser,
    workerHiredForm,
    pma,
    cvSearch,
    vetting,
    enterprise,
    massHiring,
    whatsappInbox,
    whatsappTemplates,
    interviewScheduling,
    onboarding,
    screeningQuestions,
    onboardingTasks,
    interviewEvaluations,
}

export default appReducer